export default __webpack_public_path__ + "static/media/908.e5017328.png";